import type { IStoreApiPort } from '@personnel/application/ports/IStoreApiPort';
import type { Store } from '@personnel/domain/entities/Store';

export const getStoresUseCase = (props: { apiPort: IStoreApiPort }) => {
  const { apiPort } = props;

  const execute = async (request: { organizationUuid?: string; storeUuid?: string }): Promise<Store[]> => {
    return apiPort.getStores(request);
  };

  return { execute };
};
